import * as React from 'react'
import { useTheme } from '@mui/material'

const LiveChatIcon = (props) => {
  const theme = useTheme()

  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle
        cx={35}
        cy={35}
        r={34.125}
        fill={props.backgroundColor ? props.backgroundColor : theme.palette.brandless.icon.white.color}
        stroke={props.borderColor ? props.borderColor : theme.palette.brandless.icon.black.color}
        strokeWidth={1.75}
      />
      <path
        d="M26.7128 42.9261H15.9559C15.0876 42.9261 14.649 41.8724 15.2643 41.2566L17.524 38.997C15.273 36.6408 14 33.4937 14 30.2132C14 23.2033 19.703 17.5 26.7132 17.5C33.7233 17.5 39.4263 23.203 39.4263 30.2132C39.4263 37.2233 33.7233 42.9263 26.7132 42.9263L26.7128 42.9261ZM18.3166 40.9702H26.7128C32.6442 40.9702 37.4696 36.1445 37.4696 30.2134C37.4696 24.2822 32.6439 19.4565 26.7128 19.4565C20.7816 19.4565 15.9559 24.2822 15.9559 30.2134C15.9559 33.2819 17.2726 36.2129 19.5686 38.2547C19.9891 38.6284 20.0076 39.2798 19.6105 39.6768L18.3166 40.9702Z"
        fill={props.color ? props.color : theme.palette.brandless.icon.black.color}
      />
      <path
        d="M53.1161 50.7493H42.3592C36.6377 50.7493 31.5934 46.8973 30.0922 41.3827C29.9504 40.8616 30.2577 40.3241 30.7792 40.1823C31.3003 40.0405 31.8378 40.3478 31.9796 40.8689C33.2495 45.535 37.5177 48.7936 42.3592 48.7936H50.7553L49.4616 47.4999C49.0645 47.1028 49.0823 46.4518 49.5035 46.0778C51.7996 44.036 53.1162 41.1051 53.1162 38.0364C53.1162 32.105 48.2905 27.2795 42.3593 27.2795C40.9905 27.2795 39.6571 27.5331 38.3963 28.0329C37.8944 28.232 37.3258 27.9864 37.1268 27.4842C36.9277 26.982 37.1732 26.4137 37.6755 26.2147C39.1668 25.6234 40.7427 25.3237 42.3594 25.3237C49.3693 25.3237 55.0726 31.0267 55.0726 38.0369C55.0726 41.3174 53.7995 44.4647 51.5486 46.8207L53.8082 49.0803C54.088 49.3601 54.1714 49.7806 54.0202 50.1459C53.8686 50.5116 53.5124 50.7498 53.1167 50.7498L53.1161 50.7493Z"
        fill={props.color ? props.color : theme.palette.brandless.icon.black.color}
      />
      <path
        d="M27.6912 27.2792H20.8458C20.3058 27.2792 19.8678 26.8412 19.8678 26.3012C19.8678 25.7612 20.3058 25.3232 20.8458 25.3232H27.6912C28.2311 25.3232 28.6691 25.7612 28.6691 26.3012C28.6691 26.8412 28.2312 27.2792 27.6912 27.2792Z"
        fill={props.color ? props.color : theme.palette.brandless.icon.black.color}
      />
      <path
        d="M32.5799 31.1903H20.8449C20.305 31.1903 19.8669 30.7523 19.8669 30.2123C19.8669 29.6723 20.3049 29.2344 20.8449 29.2344H32.5799C33.1199 29.2344 33.5579 29.6723 33.5579 30.2123C33.5579 30.7523 33.1199 31.1903 32.5799 31.1903Z"
        fill={props.color ? props.color : theme.palette.brandless.icon.black.color}
      />
      <path
        d="M32.5799 35.1028H20.8449C20.305 35.1028 19.8669 34.6648 19.8669 34.1248C19.8669 33.5848 20.3049 33.1469 20.8449 33.1469H32.5799C33.1199 33.1469 33.5579 33.5848 33.5579 34.1248C33.5579 34.6648 33.1199 35.1028 32.5799 35.1028Z"
        fill={props.color ? props.color : theme.palette.brandless.icon.black.color}
      />
    </svg>
  )
}
export default LiveChatIcon
